export default class SubProductModel {
  id

  code

  fullName

  name

  available

  price

  salePrice

  constructor (item = {}) {
    this.id = item.id
    this.name = item.name || ''
    this.fullName = item.fullName || ''
    this.code = item.code || ''
    this.price = item.price || 0
    this.available = item.available || 0
    this.salePrice = item.salePrice || 0
  }
}
